<template>
  <div class="order">
    <v-app-bar
      app
      color="primary"
      dense
      :class="[{ '' /**desktop-mode-padding */: $vuetify.breakpoint.mdAndUp }, 'header', 'primaryText--text']"
    >
      <v-row>
        <v-col cols="2" style="display: flex">
          <v-app-bar-nav-icon v-if="newOrder" @click="navBack">
            <v-icon>mdi-arrow-left</v-icon>
          </v-app-bar-nav-icon>
        </v-col>

        <v-col cols="8" class="d-flex justify-center">
          <div>
            <v-toolbar-title
              class="header-title1"
              v-if="$store.state.store != null && $store.state.store.info != null"
              >{{ $store.getters.storeName }}</v-toolbar-title
            >
            <v-toolbar-title class="header-title2"
              >{{ $t($store.getters.orderFrom) }}
              <span class="header-title2-feature">{{ $t("order") }}</span></v-toolbar-title
            >
          </div>
        </v-col>

        <v-col cols="2" align-self="end" style="text-align: right">
          <v-app-bar-nav-icon v-if="!newOrder" @click="placeOrder">
            <v-icon>mdi-check</v-icon>
          </v-app-bar-nav-icon>
        </v-col>
      </v-row>
    </v-app-bar>

    <v-container v-if="$store.state.store != null" class="mt-n3">
      <div class="orderitem-info-box">
        <v-row>
          <v-col>
            <div class="item-descr" v-if="$store.state.descrIndex == 0">
              {{ orderItem.ord_descr }}
            </div>
            <div class="item-descr" v-if="$store.state.descrIndex == 1">
              {{ orderItem.ord_descr1 }}
            </div>
            <div class="item-descr" v-if="$store.state.descrIndex == 2">
              {{ orderItem.ord_descr2 }}
            </div>
          </v-col>
        </v-row>

        <v-row v-if="orderItem.item != null && orderItem.item.scalable && orderItem.item.weight > 0">
          <v-col class="item-scale">
            {{ orderItem.item.weight }} {{ orderItem.item.weightUnit }} @ {{ orderItem.price | currency }}
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="4"
            ><span v-if="orderItem.redeemItem" class="points">{{ orderItem.redeemPoints }} pts</span></v-col
          >
          <v-col cols="4" class="text-center">
            <div v-if="showItemPrice">
              <span v-if="itemSubtotal != itemDiscountedSubtotal" class="price-crossout price">{{
                itemSubtotal | currency
              }}</span>
              <span class="price"> {{ itemDiscountedSubtotal | currency }}</span>
            </div>
            <div v-else-if="showBundlePrice">
              <span v-if="bundleItemPrice != bundleItemDiscountedPrice" class="price-crossout price">{{
                bundleItemPrice | currency
              }}</span>
              <span class="price"> {{ bundleItemDiscountedPrice | currency }}</span>
            </div>
          </v-col>
          <v-col cols="4" class="text-right"> </v-col>
        </v-row>
      </div>

      <div
        v-if="
          $store.state.showItemImageInOrder &&
            orderItem !== undefined &&
            orderItem.item !== undefined &&
            orderItem.item.imageUri !== undefined &&
            orderItem.item.imageUri != null &&
            orderItem.item.imageUri != ''
        "
        class="mx-n3"
      >
        <v-img :src="orderItem.item.imageUri" class="item-image mb-1" />
      </div>

      <div v-if="$store.state.descrIndex == 0 && orderItem.item !== undefined && orderItem.item.detail != ''">
        <v-row>
          <v-col>
            {{ orderItem.item.detail }}
          </v-col>
        </v-row>
      </div>
      <div v-else-if="$store.state.descrIndex == 1 && orderItem.item !== undefined && orderItem.item.detail1 != ''">
        <v-row>
          <v-col>
            {{ orderItem.item.detail1 }}
          </v-col>
        </v-row>
      </div>
      <div v-else-if="$store.state.descrIndex == 2 && orderItem.item !== undefined && orderItem.item.detail2 != ''">
        <v-row>
          <v-col>
            {{ orderItem.item.detail2 }}
          </v-col>
        </v-row>
      </div>

      <div v-for="og in orderItem.options" :key="og.ID">
        <v-row align="center" class="option-group-row">
          <v-col>
            <div v-if="og.ID >= 800000">
              {{ $t(og.name) }}
            </div>
            <div v-if="og.ID < 800000">
              <span v-if="$store.state.descrIndex == 0">
                {{ og.name }}
              </span>
              <span v-if="$store.state.descrIndex == 1">
                {{ og.name1 }}
              </span>
              <span v-if="$store.state.descrIndex == 2">
                {{ og.name2 }}
              </span>
            </div>
          </v-col>

          <v-col v-if="og.qty > 0" cols="2" lg="1" class="option-group-sel">
            {{ og.qty }}
          </v-col>
          <v-col v-if="og.max > 0" cols="3" lg="2" class="option-group-max">
            {{ $t("item_option_upto") }}:{{ og.max }}
          </v-col>
          <v-col v-if="og.min > 0" cols="3" lg="2" class="option-group-min">
            {{ $t("item_option_require") }}:{{ og.min }}
          </v-col>
        </v-row>

        <v-row v-if="og.chgqty > 0 && og.chgway == 0" class="option-group-row-charge-info">
          <v-col class="text-center">{{ $t("item_option_charge_free", { value: og.chgqty }) }} </v-col>
        </v-row>

        <v-row v-if="og.chgqty > 0 && og.chgway == 1" class="option-group-row-charge-info">
          <v-col class="text-center">{{ $t("item_option_charge_lowest", { value: og.chgqty }) }} </v-col>
        </v-row>
        <v-row v-if="og.chgqty > 0 && og.chgway == 2" class="option-group-row-charge-info">
          <v-col class="text-center">{{ $t("item_option_charge_highest", { value: og.chgqty }) }} </v-col>
        </v-row>

        <div v-if="!og.opt" class="option-grid">
          <v-row align="center" class="option-item" v-for="opt in og.items" :key="opt.ID">
            <v-col cols="6">
              <div class="option-descr">
                <span v-if="$store.state.descrIndex == 0">
                  {{ opt.descr }}
                </span>
                <span v-if="$store.state.descrIndex == 1">
                  {{ opt.descr1 }}
                </span>
                <span v-if="$store.state.descrIndex == 2">
                  {{ opt.descr2 }}
                </span>
              </div>
            </v-col>

            <v-col cols="3" class="text-right">
              <span v-show="getOptionPriceVisibility(opt)" class="option-price">{{
                getOptionPrice(opt) | currency
              }}</span>
            </v-col>

            <v-col cols="3" class="text-right option-toggle-col">
              <v-switch
                class="v-switch-right"
                hide-details
                :ripple="false"
                color="secondary"
                v-if="!opt.soldout"
                v-model="opt.toggle"
                @change="toggleOption(og, opt)"
              ></v-switch>
              <span v-else class="option-soldout">
                {{ $t("soldout") }}
              </span>
            </v-col>
          </v-row>
        </div>

        <div v-if="og.opt" class="option-grid">
          <v-row align="center" class="option-item" v-for="opt in og.items" :key="opt.ID">
            <v-col cols="6">
              <div class="option-descr">
                <span v-if="$store.state.descrIndex == 0">
                  {{ opt.descr }}
                </span>
                <span v-if="$store.state.descrIndex == 1">
                  {{ opt.descr1 }}
                </span>
                <span v-if="$store.state.descrIndex == 2">
                  {{ opt.descr2 }}
                </span>
              </div>
            </v-col>

            <v-col cols="3" class="text-right">
              <span v-show="getOptionPriceVisibility(opt)" class="option-price">
                {{ getOptionPrice(opt) | currency }}</span
              >
            </v-col>

            <v-col cols="3" class="text-right">
              <div v-if="opt.soldout" class="option-soldout">
                {{ $t("soldout") }}
              </div>
              <div v-else class="option-qty-box">
                <v-icon @click="updateOptionQty(og, opt, 1)">mdi-plus</v-icon>
                <span class="qty">{{ opt.qty }}</span>
                <v-icon @click="updateOptionQty(og, opt, -1)">mdi-minus</v-icon>
              </div>
            </v-col>
          </v-row>
        </div>
      </div>

      <div class="mb-8" v-if="!$store.getters.storeMenuMode">
        <v-textarea
          v-if="!hideItemRemark"
          :x-label="$t('special_instruction')"
          :x-placeholder="$t('special_instruction_placeholder')"
          maxlength="100"
          color="accent"
          class="item-remark"
          v-model="orderItem.remark"
        >
          <template v-slot:label>
            <div class="font-weight-bold accent--text">{{ $t("special_instruction") }}</div>
          </template>
        </v-textarea>
        <div v-else class="order-call-for-request">
          {{ $t("call_for_request") }}
        </div>
      </div>
    </v-container>

    <v-footer
      fixed
      v-show="$store.state.routeFrom.name != 'OrderBundle' && !$store.getters.storeMenuMode"
      :class="[{ '' /**'desktop-mode-padding-right'*/ /**desktop-mode-padding */: $vuetify.breakpoint.mdAndUp }]"
    >
      <v-row align="center">
        <v-col :class="[{ 'pl-6': $vuetify.breakpoint.mdAndUp }]"> {{ $t("quantity") }}</v-col>
        <v-col class="text-center">
          <v-icon
            class="order-qty-button"
            v-show="orderItem.cbRefID == 0"
            :disabled="orderItem.cbRefID > 0"
            @click="updateOrderQty(1)"
          >
            mdi-plus
          </v-icon>
          <span class="order-qty">{{ orderItem.qty }}</span>
          <v-icon
            class="order-qty-button"
            v-show="orderItem.cbRefID == 0"
            :disabled="orderItem.cbRefID > 0"
            @click="updateOrderQty(-1)"
          >
            mdi-minus
          </v-icon>
        </v-col>
        <v-col :class="[{ 'pr-6': $vuetify.breakpoint.mdAndUp }, 'text-right']">
          <v-btn color="info" class="order-button infoText--text" v-show="newOrder" @click="placeOrder">{{
            $t("placeorder")
          }}</v-btn>
        </v-col>
      </v-row>
    </v-footer>

    <v-overlay :value="refreshing">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
export default {
  data() {
    return {
      refreshing: false,

      orderItem: {},
      bundleItem: null,
      newOrder: true,

      validOrder: false,
      sideOrder: false,
    };
  },

  beforeRouteLeave(to, from, next) {
    next(this.newOrder || this.validOrder);
  },

  mounted() {},

  activated() {
    console.log("order activated", this.$route.params);

    this.item = null;
    this.bundleItem = null;
    this.orderItem = null;
    this.validOrder = false;
    this.sideOrder = false;
    if (this.$route.params.sideOrder != null) this.sideOrder = this.$route.params.sideOrder;

    if (this.$route.params.bundleItem !== undefined) {
      this.bundleItem = this.$route.params.bundleItem;
      this.orderItem = this.bundleItem.orderItem;
      this.newOrder = false;
    } else if (this.$route.params.item !== undefined) {
      let item = this.$route.params.item;
      this.orderItem = this.itemToOrderItem(item);
      this.newOrder = true;
    } else if (this.$route.params.orderItem !== undefined) {
      this.orderItem = this.$route.params.orderItem;
      this.newOrder = false;
    }

    this.updateOptionGroupRowTop();

    /*
    console.log("bundleItem", this.bundleItem);
    console.log("orderItem", this.orderItem);
    console.log("newOrder", this.newOrder);
    */
  },

  computed: {
    hideItemRemark() {
      return this.$store.state.store.config.hideItemRemark;
    },

    hideOrderRemark() {
      return this.$store.state.store.config.hideOrderRemark;
    },

    itemSubtotal() {
      return this.getOrderItemSubtotal(this.orderItem);
    },

    itemDiscountedSubtotal() {
      return this.getOrderItemDiscountedSubtotal(this.orderItem);
    },

    bundleItemPrice() {
      let biPrice = 0;
      if (this.bundleItem != null && this.bundleItem.bItem) {
        biPrice = this.getOrderItemSubtotal(this.bundleItem.orderItem); // - this.bundleItem.itemPrice;
      }

      return biPrice;
    },

    bundleItemDiscountedPrice() {
      let biPrice = 0;
      if (this.bundleItem != null && this.bundleItem.bItem) {
        biPrice = this.getOrderItemDiscountedSubtotal(this.bundleItem.orderItem);
        /*
        biPrice = this.bundleItemPrice;
        if (this.bundleItem.orderItem.itemDiscountable && this.bundleItem.orderItem.itemDiscountRate > 0) {
          biPrice = biPrice * (1 - this.bundleItem.orderItem.itemDiscountRate / 100);

          if (!this.bundleItem.orderItem.optionDiscountable) {
            biPrice += this.bundleItem.orderItem.optionValue * (this.bundleItem.orderItem.itemDiscountRate / 100);
          }
        }
        */
      }

      return biPrice;
    },

    showItemPrice() {
      return this.bundleItem == null || !this.bundleItem.bItem;
    },

    showBundlePrice() {
      return (
        this.bundleItem != null &&
        this.bundleItem.bItem &&
        (this.bundleItem.applyDiff == "all" ||
          (this.bundleItem.applyDiff == "higher" && this.bundleItemPrice > 0) ||
          (this.bundleItem.applyDiff == "lower" && this.bundleItemPrice < 0))
      );
    },
  },

  methods: {
    onClickMenu() {
      this.$store.state.appBar.showDrawer = true;
    },

    getOptionPriceVisibility(opt) {
      let optionPrice = this.getOptionPrice(opt);
      return (this.showItemPrice || this.showBundlePrice) && optionPrice != 0;
      /*
      return (
        (this.orderItem.itemDiscountable ? opt.price * (1 - this.orderItem.itemDiscountRate / 100) : opt.price) != 0 &&
        (this.showItemPrice || this.showBundlePrice) &&
        (this.orderItem.combos == null || this.orderItem.cbRefID == 0 || this.orderItem.combo.optionOntop)
      );
      */
    },

    getOptionPrice(opt) {
      let optionPrice = opt.price;
      if (this.orderItem.combo != null && !this.isEmptyObject(this.orderItem.combo)) {
        let cb = this.orderItem.combo;
        if (cb.optionOntop) {
          let optionDiscountRate = cb.optionDiscountable ? cb.discountRate : 0;
          optionPrice = this.roundNumber(optionPrice * (1 - optionDiscountRate / 100), 2);
        } else optionPrice = 0;
      } else if (
        this.orderItem.itemDiscountable &&
        this.orderItem.optionDiscountable &&
        this.orderItem.itemDiscountRate > 0
      ) {
        optionPrice = optionPrice * (1 - this.orderItem.itemDiscountRate / 100);
      }

      return optionPrice;
      //return this.orderItem.itemDiscountable ? opt.price * (1 - this.orderItem.itemDiscountRate / 100) : opt.price;
    },

    updateOrderQty(qty) {
      this.orderItem.qty = this.orderItem.qty + qty;
      if (this.orderItem.qty < 1) this.orderItem.qty = 1;
    },

    toggleOption(optionGroup, option) {
      // Rollback toggle state if toggle options exceed max options in group
      let valid = true;

      let cg_qty = 0;
      for (let opt of optionGroup.items) {
        if (opt.toggle) cg_qty++;
      }
      if (option.toggle && optionGroup.max > 0) {
        if (cg_qty > optionGroup.max) {
          if (optionGroup.max == 1) {
            for (let opt of optionGroup.items) {
              if (opt.toggle && opt.ID != option.ID) {
                opt.toggle = false;
                opt.qty = 0;
                cg_qty--;

                for (var ii = 0; ii < optionGroup.ordered.length; ii++) {
                  if (optionGroup.ordered[ii].ID == opt.ID) {
                    optionGroup.ordered.splice(ii, 1);
                    break;
                  }
                }
                break;
              }
            }
          } else {
            valid = false;
          }
        }
      }

      if (valid) {
        optionGroup.qty = cg_qty;

        if (optionGroup.ordered == null) {
          optionGroup.ordered = Array();
        }

        if (option.toggle) {
          let oo = {
            cgID: optionGroup.ID,
            ID: option.ID,
            optionPrice: option.price,
            price: option.price,
            time: Date.now(),
          };
          optionGroup.ordered.push(oo);
        } else {
          for (var i = 0; i < optionGroup.ordered.length; i++) {
            if (optionGroup.ordered[i].ID == option.ID) {
              optionGroup.ordered.splice(i, 1);
              break;
            }
          }
        }

        option.qty = option.toggle ? 1 : 0;

        this.updateOptionsValue(this.orderItem);
        this.updateOrderDescription();
      } else
        setTimeout(() => {
          option.toggle = false;
          option.qty = 0;
        }, 0);
    },

    updateOptionQty(optionGroup, option, qty) {
      if (option.max !== undefined && option.max > 0) {
        let opt_qty = 0;
        for (let opt of optionGroup.items) {
          if (opt.ID == option.ID) {
            opt_qty += opt.qty;
          }
        }
        if (opt_qty + qty > option.max) return;
      }

      // Rollback option qty if selected options exceed max options in group
      let cg_qty = qty;
      for (let opt of optionGroup.items) {
        cg_qty += opt.qty;
      }
      if (cg_qty < 0) cg_qty = 0;

      let valid = true;
      if (optionGroup.max > 0) {
        if (cg_qty > optionGroup.max) {
          cg_qty -= qty;
          valid = false;
        }
      }
      optionGroup.qty = cg_qty;

      if (valid) {
        if (optionGroup.ordered == null) {
          optionGroup.ordered = Array();
        }

        option.qty = option.qty + qty;
        if (option.qty < 0) option.qty = 0;
        else {
          if (qty > 0) {
            let oo = {
              cgID: optionGroup.ID,
              ID: option.ID,
              optionPrice: option.price,
              price: option.price,
              time: Date.now(),
            };
            optionGroup.ordered.push(oo);
          } else if (qty < 0) {
            optionGroup.ordered.sort(this.sortOptionByLatestTime);
            for (var i = 0; i < optionGroup.ordered.length; i++) {
              if (optionGroup.ordered[i].ID == option.ID) {
                optionGroup.ordered.splice(i, 1);
                break;
              }
            }
          }
        }

        this.updateOptionsValue(this.orderItem);
        this.updateOrderDescription();
      }
    },

    updateOrderDescription() {
      this.orderItem.ord_descr = this.getOrderText(this.orderItem, 0);
      this.orderItem.ord_descr1 = this.getOrderText(this.orderItem, 1);
      this.orderItem.ord_descr2 = this.getOrderText(this.orderItem, 2);

      this.updateOptionGroupRowTop();
    },

    updateOptionGroupRowTop() {
      setTimeout(() => {
        //console.log("updateOptionGroupRowTop");

        let infoBox = document.querySelector(".orderitem-info-box");
        let ogRowAll = document.querySelectorAll(".option-group-row");

        //console.log(infoBox, ogRowAll);
        if (infoBox == null || ogRowAll == null) return;

        let infoBoxTop = infoBox.getBoundingClientRect().top;
        let infoBoxHeight = infoBox.offsetHeight;

        ogRowAll.forEach(ogr => {
          ogr.style.top = infoBoxTop + infoBoxHeight + "px";
        });
      }, 10);
    },

    checkOrder() {
      let invalid_og;
      for (let og of this.orderItem.options) {
        if (og.min > 0 && og.qty < og.min) {
          invalid_og = og;
          break;
        }
      }

      if (invalid_og) {
        this.$root.messageDialog(
          this.$t("error_min_option_title"),
          "",
          this.$t("error_min_option_msg", {
            opt_min: invalid_og.min,
            opt_group_name: invalid_og.name,
          })
        );
      }

      return invalid_og;
    },

    placeOrder() {
      if (this.newOrder && !this.$store.getters.acceptOrder) {
        this.$root.messageDialog(this.$t("not_acception_order"), "", this.$t("not_acception_order_message"));
        return;
      }

      let invalid_og = this.checkOrder();
      if (invalid_og == null) {
        if (this.newOrder) {
          this.addOrderItem(this.orderItem);
        } else {
          this.calculateTotal();
          this.setOrderToStorage();
        }

        this.validOrder = true;
        this.navBack();

        if (this.sideOrder) {
          setTimeout(() => {
            this.navBack();
          }, 0);
        } else {
          if (this.newOrder && this.orderItem.tag != "" && this.orderItem.cbRefID == 0) {
            let sideItemIDs = this.$store.state.items
              .filter(x => x.combos != null && x.combos.some(x1 => x1.tag == this.orderItem.tag))
              /*
              .sort(function(a, b) {
                return a.catID - b.catID;
              })
              */
              .map(y => y.ID);

            if (sideItemIDs.length > 0) {
              this.$root
                .confirmDialog(this.$t("confirm_add_side_item"), "", this.$t("confirm_add_side_item_later"))
                .then(resp => {
                  if (resp) {
                    setTimeout(() => {
                      this.navName("MenuItem", { itemIDs: sideItemIDs, sideOrder: true });
                    }, 0);
                  }
                });
            }
          }
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/sass/variables.scss";

.orderitem-info-box {
  padding: 8px 0px;
  position: sticky;
  top: calc(#{$header-height});
  z-index: 2;
  background-color: white;
  margin-left: -12px;
  margin-right: -12px;

  .row {
    margin: 0px;
  }
  .col {
    padding: 0px;
  }
  .item-descr {
    font-size: 1.1em;
    text-align: center;
    padding: 0px 4px;
    padding-bottom: 4px;
    white-space: pre-line !important;
    max-height: 150px;
    overflow: auto;
  }

  .item-scale {
    font-size: 0.9em;
    text-align: center;
    padding: 0px 4px;
    padding-bottom: 4px;
    white-space: pre-line !important;
    overflow: auto;
  }

  .points {
    font-size: 1em;
    font-weight: bold;
    padding-left: 12px;
  }

  .price {
    font-size: 1.2em;
  }

  .price-crossout {
    text-decoration: line-through;
    color: var(--v-accent-base);
  }
}

.item-image {
  max-height: 300px;
  //max-height: 40%;
  //height: auto;
  //width: auto;
  //object-fit: cover;

  //display: block;
  //padding: 12px 0px;
  //margin-left: -12px;
  //margin-right: -12px;
}

@media screen and (min-width: 600px) {
  .item-image {
    max-width: 375px;
    margin-left: auto;
    margin-right: auto;
    border-radius: 12px;
  }
}

.option-group-row {
  background-color: var(--v-secondary-lighten1);
  color: var(--v-secondaryText-base);
  position: sticky;
  top: 0px;
  z-index: 1;

  .col {
    min-height: 48px;
  }

  .option-group-sel {
    background-color: white;
    color: black;
    text-align: center;
  }

  .option-group-max {
    background-color: var(--v-warning-base);
    //color: white;
    color: var(--v-warningText-base);
    text-align: center;
    white-space: nowrap;
  }

  .option-group-min {
    background-color: var(--v-accent-base);
    //color: white;
    color: var(--v-accentText-base);
    text-align: center;
    white-space: nowrap;
  }
}

.option-group-row-charge-info {
  background-color: rgb(230, 230, 230);
  //color: var(--v-accent-base);
}

.option-price {
  font-size: 1em;
  font-weight: bold;
}

.option-soldout {
  color: var(--v-warning-base);
}

.option-qty-box {
  display: flex;
  align-items: center;
  justify-content: flex-end;

  .qty {
    padding: 0px 8px;
  }
}

.v-footer {
  padding-bottom: calc(6px + env(safe-area-inset-bottom));

  .col {
    padding: 0px;
  }

  .order-qty {
    font-size: 1.5em;
    padding: 0px 12px;
    vertical-align: sub;
  }

  .order-qty-button {
    font-size: 1.5em;
  }

  .order-button {
    padding: 0px 8px !important;
    font-size: 0.9em;
  }
}
</style>
